import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SolutionsGrid from './components/SolutionsGrid';
import OurApproach from './components/OurApproach';
import SavingsCalculator from './components/SavingsCalculator';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import SEO, { buildBreadcrumbSchema } from '@/components/SEO';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Fore Capital',
    url: SITE_URL,
    description: 'Custom payment infrastructure for modern merchants. Omnichannel payments, gateway, fraud prevention, POS integration, and developer-first APIs.',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/solutions?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  buildBreadcrumbSchema([
    { name: 'Home', href: '/' },
  ]),
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'How is Fore Capital different from other payment processors?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Most processors sell you a rate and disappear. We stay embedded — auditing your current setup, building custom infrastructure, and optimizing continuously. You get full visibility into every fee, real-time reporting, and a partner who actually answers the phone.',
        },
      },
      {
        '@type': 'Question',
        name: 'What does the free analysis include?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We review your last 3 months of processing statements, identify hidden fees and markups, benchmark your rates against industry standards, and deliver a clear report showing exactly how much you are overpaying — with no obligation.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long does implementation take?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Most clients are fully integrated within 30 to 60 days. Complex multi-channel setups may take longer, but we stay hands-on throughout and never hand you off to a support queue.',
        },
      },
      {
        '@type': 'Question',
        name: 'Will switching processors disrupt my business?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. We design the transition to run parallel with your existing system until everything is tested and confirmed. Your customers never see downtime, and your cash flow stays uninterrupted.',
        },
      },
      {
        '@type': 'Question',
        name: 'What industries do you specialize in?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We focus on retail, hospitality, e-commerce, and enterprise — businesses with complex payment flows, multiple channels, and high transaction volumes. If you process more than $500K annually, we are built for you.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do you support international payments?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. Our infrastructure supports multi-currency processing, cross-border payouts, and compliance with regional regulations across North America, Europe, and Asia-Pacific.',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-[#F9F9F7]" style={{ fontFamily: "'Google Sans Flex', sans-serif" }}>
      <SEO
        title="Fore Capital | Payment Infrastructure for Modern Merchants"
        description="Custom payment infrastructure for modern merchants. Omnichannel payments, gateway, fraud prevention, POS integration, and developer-first APIs. Built for retail, hospitality, e-commerce, and enterprise."
        keywords="payment infrastructure, merchant processing, omnichannel payments, payment gateway, fraud prevention, POS integration"
        pathname="/"
        schema={homeSchema}
      />
      <Navbar />
      <main>
        <Hero />
        <SolutionsGrid />
        <OurApproach />
        <SavingsCalculator />
        <CTABanner />

      </main>
      <Footer />
    </div>
  );
}